const ResetPassword = () => {
    return (
        <>
            <div className="container">
                <div className="col-md-12">
                    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
                        <div className="card shadow-sm" style={{ width: "100%", maxWidth: "400px" }}>
                            <div className="card-header">
                                <div className="card-title"> Reset Password</div>
                            </div>
                            <div className="card-body">
                                <form>
                                    <label className="form-label fw-bold">New Password</label>
                                    <input
                                        type="password"
                                        placeholder="New Password"
                                        className="form-control "
                                    />
                                    <label className="form-label fw-bold mt-2">Confirm Password</label>
                                    <input
                                        type="password"
                                        placeholder="Confirm New Password"
                                        className="form-control"
                                    />

                                    <p className="mt-3 text-success"></p>

                                    <button className="btn btn-black mt-3 w-100" >
                                        Update Password
                                    </button>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ResetPassword;
